import { Directive, EventEmitter, HostListener, Output } from '@angular/core'

@Directive({
  selector: '[voiceRecord]',
  exportAs: 'voiceRecord',
  standalone: false,
})
export class VoiceRecordDirective {
  @Output() voice = new EventEmitter<Blob>()
  isRecording = false
  audioChunks: BlobPart[] = []
  mediaRecorder: MediaRecorder
  constructor() {}

  @HostListener('click')
  onClick() {
    if (this.isRecording) {
      this.mediaRecorder?.stop()
    } else {
      this.onStart()
    }
  }

  async onStart() {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
    this.mediaRecorder = new MediaRecorder(stream)
    this.mediaRecorder.start()
    this.isRecording = true

    this.mediaRecorder.addEventListener('dataavailable', (event) => {
      this.audioChunks.push(event.data)
    })

    this.mediaRecorder.addEventListener('error', async () => {
      this.clear()
    })

    this.mediaRecorder.addEventListener('stop', async () => {
      this.voice.emit(new Blob(this.audioChunks))
      this.clear()
    })
  }

  clear() {
    this.mediaRecorder?.stream.getTracks().forEach((track) => track.stop())
    this.mediaRecorder = null
    this.isRecording = false
    this.audioChunks = []
  }
}
